// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".holder-style[data-v-22b51c94]{display:none;z-index:2147483647;position:fixed;top:0;bottom:0;left:0;right:0}", ""]);
// Exports
module.exports = exports;
